<template>
  <!--begin::Header-->
  <div id="kt_header" style="" class="header align-items-stretch">
    <!--begin::Container-->
    <div class="container-fluid d-flex align-items-stretch justify-content-between">
      <!--begin::Aside mobile toggle-->
      <div class="d-flex align-items-center d-lg-none ms-n3 me-1" title="Show aside menu">
        <div class="btn btn-icon btn-active-color-white" id="kt_aside_mobile_toggle">
          <i class="bi bi-list fs-1"></i>
        </div>
      </div>
      <!--end::Aside mobile toggle-->
      <!--begin::Mobile logo-->
      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
        <a href="../../demo13/dist/index.html" class="d-lg-none">
          <img alt="Logo" :src="`${publicPath}logo.png`" class="h-25px" />
        </a>
      </div>
      <!--end::Mobile logo-->
      <!--begin::Wrapper-->
      <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
        <!--begin::Navbar-->
        <div class="d-flex align-items-stretch" id="kt_header_nav">
          <!--begin::Menu wrapper-->
<!--          <div class="header-menu align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_header_menu_mobile_toggle" data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">-->
<!--            &lt;!&ndash;begin::Menu&ndash;&gt;-->
<!--            <div class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch" id="#kt_header_menu" data-kt-menu="true">-->
<!--              <div data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start" class="menu-item here show menu-lg-down-accordion me-lg-1">-->
<!--												<span class="menu-link py-3">-->
<!--													<span class="menu-title">Dashboards</span>-->
<!--													<span class="menu-arrow d-lg-none"></span>-->
<!--												</span>-->
<!--                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link active py-3" href="../../demo13/dist/index.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Multipurpose</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/ecommerce.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">eCommerce</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/marketing.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Marketing</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/logistics.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Logistics</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/delivery.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Delivery</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/online-courses.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Online Courses</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/website-analytics.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Website Analytics</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/finance-performance.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Finance Performance</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/store-analytics.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Store Analytics</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/social.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Social</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/crypto.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Crypto</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/school.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">School</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/dashboards/bidding.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Bidding</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/landing.html">-->
<!--															<span class="menu-bullet">-->
<!--																<span class="bullet bullet-dot"></span>-->
<!--															</span>-->
<!--                      <span class="menu-title">Landing</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-lg-1">-->
<!--												<span class="menu-link py-3">-->
<!--													<span class="menu-title">Crafted</span>-->
<!--													<span class="menu-arrow d-lg-none"></span>-->
<!--												</span>-->
<!--                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-archive fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Pages</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Profile</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/user-profile/overview.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Overview</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/user-profile/projects.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Projects</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/user-profile/campaigns.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Campaigns</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/user-profile/documents.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Documents</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/user-profile/followers.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Followers</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/user-profile/activity.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Activity</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Blog</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/blog/home.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Blog Home</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/blog/post.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Blog Post</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Pricing</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/pricing/pricing-1.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Pricing 1</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/pricing/pricing-2.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Pricing 2</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Careers</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/careers/list.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Careers List</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/careers/apply.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Careers Apply</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">FAQ</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/faq/classic.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Classic</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/pages/faq/extended.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Extended</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/pages/about.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">About Us</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/pages/contact.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Contact Us</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/pages/team.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Our Team</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/pages/licenses.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Licenses</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/pages/sitemap.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Sitemap</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-person fs-2"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Account</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/overview.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Overview</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/settings.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Settings</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/security.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Security</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/billing.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Billing</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/statements.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Statements</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/referrals.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Referrals</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/api-keys.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">API Keys</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/account/logs.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Logs</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-sticky fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Authentication</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Basic Layout</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/basic/sign-in.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Sign-in</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/basic/sign-up.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Sign-up</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/basic/two-steps.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Two-steps</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/basic/password-reset.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Password Reset</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/basic/new-password.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">New Password</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Aside Layout</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/aside/sign-in.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Sign-in</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/aside/sign-up.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Sign-up</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/aside/two-steps.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Two-steps</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/aside/password-reset.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Password Reset</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/aside/new-password.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">New Password</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Dark Layout</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/dark/sign-in.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Sign-in</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/dark/sign-up.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Sign-up</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/dark/two-steps.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Two-steps</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/dark/password-reset.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Password Reset</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/layouts/dark/new-password.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">New Password</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Extended</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/extended/two-factor-authentication.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Two Factor Auth</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/extended/multi-steps-sign-up.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Multi-steps Sign-up</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/extended/free-trial-sign-up.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Free Trial Sign-up</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/extended/coming-soon.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Coming Soon</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/general/welcome.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Welcome Message</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/general/verify-email.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Verify Email</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/general/password-confirmation.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Password Confirmation</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/general/deactivation.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Account Deactivation</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/general/error-404.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Error 404</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/general/error-500.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Error 500</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Email Templates</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/email/verify-email.html" target="blank">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Verify Email</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/email/invitation.html" target="blank">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Account Invitation</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/email/password-reset.html" target="blank">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Password Reset</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/authentication/email/password-change.html" target="blank">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Password Changed</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-shield-check fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Utilities</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Modals</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																		<span class="menu-link py-3">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--																			<span class="menu-title">General</span>-->
<!--																			<span class="menu-arrow"></span>-->
<!--																		</span>-->
<!--                            <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/general/invite-friends.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Invite Friends</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/general/view-users.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">View Users</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/general/upgrade-plan.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Upgrade Plan</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/general/share-earn.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Share &amp; Earn</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																		<span class="menu-link py-3">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--																			<span class="menu-title">Forms</span>-->
<!--																			<span class="menu-arrow"></span>-->
<!--																		</span>-->
<!--                            <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/forms/new-target.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">New Target</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/forms/new-card.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">New Card</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/forms/new-address.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">New Address</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/forms/create-api-key.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Create API Key</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/forms/bidding.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Bidding</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																		<span class="menu-link py-3">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--																			<span class="menu-title">Wizards</span>-->
<!--																			<span class="menu-arrow"></span>-->
<!--																		</span>-->
<!--                            <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/wizards/two-factor-authentication.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Two Factor Auth</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/wizards/create-app.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Create App</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/wizards/create-campaign.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Create Campaign</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/wizards/create-account.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Create Account</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/wizards/create-project.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Create Project</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/wizards/offer-a-deal.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Offer a Deal</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																		<span class="menu-link py-3">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--																			<span class="menu-title">Search</span>-->
<!--																			<span class="menu-arrow"></span>-->
<!--																		</span>-->
<!--                            <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/search/users.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Users</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                              <div class="menu-item">-->
<!--                                <a class="menu-link py-3" href="../../demo13/dist/utilities/modals/search/select-location.html">-->
<!--																					<span class="menu-bullet">-->
<!--																						<span class="bullet bullet-dot"></span>-->
<!--																					</span>-->
<!--                                  <span class="menu-title">Select Location</span>-->
<!--                                </a>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Search</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/search/horizontal.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Horizontal</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/search/vertical.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Vertical</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/search/users.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Users</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/search/select-location.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Location</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Wizards</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/horizontal.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Horizontal</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/vertical.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Vertical</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/two-factor-authentication.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Two Factor Auth</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/create-app.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Create App</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/create-campaign.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Create Campaign</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/create-account.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Create Account</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/create-project.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Create Project</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/utilities/wizards/offer-a-deal.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Offer a Deal</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-layers fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Widgets</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/widgets/lists.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Lists</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/widgets/statistics.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Statistics</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/widgets/charts.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Charts</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/widgets/mixed.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Mixed</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/widgets/tables.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Tables</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/widgets/feeds.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Feeds</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-lg-1">-->
<!--												<span class="menu-link py-3">-->
<!--													<span class="menu-title">Apps</span>-->
<!--													<span class="menu-arrow d-lg-none"></span>-->
<!--												</span>-->
<!--                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-cart2 fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Devs Forum</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/devs/ask.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Ask a Question</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/devs/tag.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Question Tags</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/devs/question.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">View Question</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/devs/search.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Search Questions</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-patch-check fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Projects</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/list.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">My Projects</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/project.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">View Project</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/targets.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Targets</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/budget.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Budget</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/users.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Users</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/files.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Files</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/activity.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Activity</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/projects/settings.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Settings</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-cart fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">eCommerce</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Catalog</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/catalog/products.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Products</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/catalog/categories.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Categories</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/catalog/add-product.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Add Product</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/catalog/edit-product.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Edit Product</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/catalog/add-category.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Add Category</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/catalog/edit-category.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Edit Category</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="click" class="menu-item menu-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Sales</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-accordion">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/sales/listing.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Orders Listing</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/sales/details.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Order Details</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/sales/add-order.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Add Order</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/sales/edit-order.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Edit Order</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="click" class="menu-item menu-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Customers</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-accordion">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/customers/listing.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Customers Listing</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/customers/details.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Customers Details</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="click" class="menu-item menu-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Reports</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-accordion">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/reports/view.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Products Viewed</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/reports/sales.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Sales</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/reports/returns.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Returns</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/reports/customer-orders.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Customer Orders</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/reports/shipping.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Shipping</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/ecommerce/settings.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Settings</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-hr fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Support Center</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/overview.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Overview</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Tickets</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/tickets/list.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Ticket List</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/tickets/view.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Ticket View</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Tutorials</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/tutorials/list.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Tutorials List</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/tutorials/post.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Tutorials Post</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/faq.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">FAQ</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/licenses.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Licenses</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/support-center/contact.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Contact Us</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-people fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">User Management</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Users</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/user-management/users/list.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Users List</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/user-management/users/view.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">View User</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Roles</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/user-management/roles/list.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Roles List</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/user-management/roles/view.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">View Roles</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/user-management/permissions.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Permissions</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-calendar3-event fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Contacts</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/contacts/getting-started.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Getting Started</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/contacts/add-contact.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Add Contact</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/contacts/edit-contact.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Edit Contact</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/contacts/view-contact.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">View Contact</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-cart2 fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Subscriptions</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/subscriptions/getting-started.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Getting Started</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/subscriptions/list.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Subscription List</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/subscriptions/add.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Add Subscription</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/subscriptions/view.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">View Subscription</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-printer fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Customers</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/customers/getting-started.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Getting Started</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/customers/list.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Customer Listing</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/customers/view.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Customer Details</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-hr fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Invoice Management</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--																<span class="menu-link py-3">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--																	<span class="menu-title">Profile</span>-->
<!--																	<span class="menu-arrow"></span>-->
<!--																</span>-->
<!--                        <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/invoices/view/invoice-1.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Invoice 1</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/invoices/view/invoice-2.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Invoice 2</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                          <div class="menu-item">-->
<!--                            <a class="menu-link py-3" href="../../demo13/dist/apps/invoices/view/invoice-3.html">-->
<!--																			<span class="menu-bullet">-->
<!--																				<span class="bullet bullet-dot"></span>-->
<!--																			</span>-->
<!--                              <span class="menu-title">Invoice 3</span>-->
<!--                            </a>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/invoices/create.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Create Invoice</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-folder-check fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">File Manager</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/file-manager/folders.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Folders</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/file-manager/files.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Files</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/file-manager/blank.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Blank Directory</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/file-manager/settings.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Settings</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-envelope fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Inbox</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/inbox/listing.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Messages</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/inbox/compose.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Compose</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/inbox/reply.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">View &amp; Reply</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-down-accordion">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi-chat-left fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Chat</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/chat/private.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Private Chat</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/chat/group.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Group Chat</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/apps/chat/drawer.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Drawer Chat</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/apps/calendar.html">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-calendar3-event fs-3"></i>-->
<!--															</span>-->
<!--                      <span class="menu-title">Calendar</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-lg-1">-->
<!--												<span class="menu-link py-3">-->
<!--													<span class="menu-title">Layouts</span>-->
<!--													<span class="menu-arrow d-lg-none"></span>-->
<!--												</span>-->
<!--                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">-->
<!--                  <div data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item menu-lg-dropdown">-->
<!--														<span class="menu-link py-3">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-layout-sidebar fs-3"></i>-->
<!--															</span>-->
<!--															<span class="menu-title">Aside</span>-->
<!--															<span class="menu-arrow"></span>-->
<!--														</span>-->
<!--                    <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/layouts/aside/minimized.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Minimized</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="menu-item">-->
<!--                        <a class="menu-link py-3" href="../../demo13/dist/layouts/aside/only-header.html">-->
<!--																	<span class="menu-bullet">-->
<!--																		<span class="bullet bullet-dot"></span>-->
<!--																	</span>-->
<!--                          <span class="menu-title">Only Header</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="https://preview.keenthemes.com/metronic8/demo13/layout-builder.html" title="Build your layout, preview and export HTML for server side integration" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-layers fs-3"></i>-->
<!--															</span>-->
<!--                      <span class="menu-title">Layout Builder</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-lg-1">-->
<!--												<span class="menu-link py-3">-->
<!--													<span class="menu-title">Resources</span>-->
<!--													<span class="menu-arrow d-lg-none"></span>-->
<!--												</span>-->
<!--                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/documentation/base/utilities.html" title="Check out over 200 in-house components, plugins and ready for use solutions" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">-->
<!--															<span class="menu-icon">-->
<!--																&lt;!&ndash;begin::Svg Icon | path: /icons/duotune/general/gen002.svg&ndash;&gt;-->
<!--																<span class="svg-icon svg-icon-2">-->
<!--																	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																		<path opacity="0.3" d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z" fill="black" />-->
<!--																		<path d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z" fill="black" />-->
<!--																	</svg>-->
<!--																</span>-->
<!--                                &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--															</span>-->
<!--                      <span class="menu-title">Components</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="https://preview.keenthemes.com/metronic8/demo13/layout-builder.html" title="Build your layout, preview and export HTML for server side integration" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-layers fs-3"></i>-->
<!--															</span>-->
<!--                      <span class="menu-title">Layout Builder</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/documentation/getting-started.html" title="Check out the complete documentation" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">-->
<!--															<span class="menu-icon">-->
<!--																<i class="bi bi-box fs-3"></i>-->
<!--															</span>-->
<!--                      <span class="menu-title">Documentation</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="menu-item">-->
<!--                    <a class="menu-link py-3" href="../../demo13/dist/documentation/getting-started/changelog.html">-->
<!--															<span class="menu-icon">-->
<!--																&lt;!&ndash;begin::Svg Icon | path: icons/duotune/coding/cod003.svg&ndash;&gt;-->
<!--																<span class="svg-icon svg-icon-2">-->
<!--																	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																		<path d="M16.95 18.9688C16.75 18.9688 16.55 18.8688 16.35 18.7688C15.85 18.4688 15.75 17.8688 16.05 17.3688L19.65 11.9688L16.05 6.56876C15.75 6.06876 15.85 5.46873 16.35 5.16873C16.85 4.86873 17.45 4.96878 17.75 5.46878L21.75 11.4688C21.95 11.7688 21.95 12.2688 21.75 12.5688L17.75 18.5688C17.55 18.7688 17.25 18.9688 16.95 18.9688ZM7.55001 18.7688C8.05001 18.4688 8.15 17.8688 7.85 17.3688L4.25001 11.9688L7.85 6.56876C8.15 6.06876 8.05001 5.46873 7.55001 5.16873C7.05001 4.86873 6.45 4.96878 6.15 5.46878L2.15 11.4688C1.95 11.7688 1.95 12.2688 2.15 12.5688L6.15 18.5688C6.35 18.8688 6.65 18.9688 6.95 18.9688C7.15 18.9688 7.35001 18.8688 7.55001 18.7688Z" fill="black" />-->
<!--																		<path opacity="0.3" d="M10.45 18.9687C10.35 18.9687 10.25 18.9687 10.25 18.9687C9.75 18.8687 9.35 18.2688 9.55 17.7688L12.55 5.76878C12.65 5.26878 13.25 4.8687 13.75 5.0687C14.25 5.1687 14.65 5.76878 14.45 6.26878L11.45 18.2688C11.35 18.6688 10.85 18.9687 10.45 18.9687Z" fill="black" />-->
<!--																	</svg>-->
<!--																</span>-->
<!--                                &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--															</span>-->
<!--                      <span class="menu-title">Changelog v8.0.37</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion me-lg-1">-->
<!--												<span class="menu-link py-3">-->
<!--													<span class="menu-title">Mega Menu</span>-->
<!--													<span class="menu-arrow d-lg-none"></span>-->
<!--												</span>-->
<!--                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown w-100 w-lg-600px p-5 p-lg-5">-->
<!--                  &lt;!&ndash;begin:Row&ndash;&gt;-->
<!--                  <div class="row" data-kt-menu-dismiss="true">-->
<!--                    &lt;!&ndash;begin:Col&ndash;&gt;-->
<!--                    <div class="col-lg-4 border-left-lg-1">-->
<!--                      <div class="menu-inline menu-column menu-active-bg">-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end:Col&ndash;&gt;-->
<!--                    &lt;!&ndash;begin:Col&ndash;&gt;-->
<!--                    <div class="col-lg-4 border-left-lg-1">-->
<!--                      <div class="menu-inline menu-column menu-active-bg">-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end:Col&ndash;&gt;-->
<!--                    &lt;!&ndash;begin:Col&ndash;&gt;-->
<!--                    <div class="col-lg-4 border-left-lg-1">-->
<!--                      <div class="menu-inline menu-column menu-active-bg">-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                        <div class="menu-item">-->
<!--                          <a href="#" class="menu-link">-->
<!--																		<span class="menu-bullet">-->
<!--																			<span class="bullet bullet-dot"></span>-->
<!--																		</span>-->
<!--                            <span class="menu-title">Example link</span>-->
<!--                          </a>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end:Col&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end:Row&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;end::Menu&ndash;&gt;-->
<!--          </div>-->
          <!--end::Menu wrapper-->
        </div>
        <!--end::Navbar-->
        <!--begin::Toolbar wrapper-->
        <div class="topbar d-flex align-items-stretch flex-shrink-0">
          <!--begin::Search-->
<!--          <div class="d-flex align-items-stretch">-->
<!--            &lt;!&ndash;begin::Search&ndash;&gt;-->
<!--            <div id="kt_header_search" class="d-flex align-items-stretch" data-kt-search-keypress="true" data-kt-search-min-length="2" data-kt-search-enter="enter" data-kt-search-layout="menu" data-kt-menu-trigger="auto" data-kt-menu-overflow="false" data-kt-menu-permanent="true" data-kt-menu-placement="bottom-end">-->
<!--              &lt;!&ndash;begin::Search toggle&ndash;&gt;-->
<!--              <div class="d-flex align-items-center" data-kt-search-element="toggle" id="kt_header_search_toggle">-->
<!--                <div class="topbar-item px-3 px-lg-5">-->
<!--                  &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen021.svg&ndash;&gt;-->
<!--                  <span class="svg-icon svg-icon-1">-->
<!--														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--															<rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />-->
<!--															<path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />-->
<!--														</svg>-->
<!--													</span>-->
<!--                  &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;end::Search toggle&ndash;&gt;-->
<!--              &lt;!&ndash;begin::Menu&ndash;&gt;-->
<!--              <div data-kt-search-element="content" class="menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px">-->
<!--                &lt;!&ndash;begin::Wrapper&ndash;&gt;-->
<!--                <div data-kt-search-element="wrapper">-->
<!--                  &lt;!&ndash;begin::Form&ndash;&gt;-->
<!--                  <form data-kt-search-element="form" class="w-100 position-relative mb-3" autocomplete="off">-->
<!--                    &lt;!&ndash;begin::Icon&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen021.svg&ndash;&gt;-->
<!--                    <span class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-0">-->
<!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																<rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />-->
<!--																<path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />-->
<!--															</svg>-->
<!--														</span>-->
<!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                    &lt;!&ndash;end::Icon&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Input&ndash;&gt;-->
<!--                    <input type="text" class="search-input form-control form-control-flush ps-10" name="search" value="" placeholder="Search..." data-kt-search-element="input" />-->
<!--                    &lt;!&ndash;end::Input&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Spinner&ndash;&gt;-->
<!--                    <span class="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-1" data-kt-search-element="spinner">-->
<!--															<span class="spinner-border h-15px w-15px align-middle text-gray-400"></span>-->
<!--														</span>-->
<!--                    &lt;!&ndash;end::Spinner&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Reset&ndash;&gt;-->
<!--                    <span class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 d-none" data-kt-search-element="clear">-->
<!--															&lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr061.svg&ndash;&gt;-->
<!--															<span class="svg-icon svg-icon-2 svg-icon-lg-1 me-0">-->
<!--																<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																	<rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />-->
<!--																	<rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />-->
<!--																</svg>-->
<!--															</span>-->
<!--                      &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--														</span>-->
<!--                    &lt;!&ndash;end::Reset&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Toolbar&ndash;&gt;-->
<!--                    <div class="position-absolute top-50 end-0 translate-middle-y" data-kt-search-element="toolbar">-->
<!--                      &lt;!&ndash;begin::Preferences toggle&ndash;&gt;-->
<!--                      <div data-kt-search-element="preferences-show" class="btn btn-icon w-20px btn-sm btn-active-color-primary me-1" data-bs-toggle="tooltip" title="Show search preferences">-->
<!--                        &lt;!&ndash;begin::Svg Icon | path: icons/duotune/coding/cod001.svg&ndash;&gt;-->
<!--                        <span class="svg-icon svg-icon-1">-->
<!--																	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																		<path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="black" />-->
<!--																		<path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="black" />-->
<!--																	</svg>-->
<!--																</span>-->
<!--                        &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Preferences toggle&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Advanced search toggle&ndash;&gt;-->
<!--                      <div data-kt-search-element="advanced-options-form-show" class="btn btn-icon w-20px btn-sm btn-active-color-primary" data-bs-toggle="tooltip" title="Show more search options">-->
<!--                        &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr072.svg&ndash;&gt;-->
<!--                        <span class="svg-icon svg-icon-2">-->
<!--																	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																		<path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="black" />-->
<!--																	</svg>-->
<!--																</span>-->
<!--                        &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Advanced search toggle&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Toolbar&ndash;&gt;-->
<!--                  </form>-->
<!--                  &lt;!&ndash;end::Form&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Separator&ndash;&gt;-->
<!--                  <div class="separator border-gray-200 mb-6"></div>-->
<!--                  &lt;!&ndash;end::Separator&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Recently viewed&ndash;&gt;-->
<!--                  <div data-kt-search-element="results" class="d-none">-->
<!--                    &lt;!&ndash;begin::Items&ndash;&gt;-->
<!--                    <div class="scroll-y mh-200px mh-lg-350px">-->
<!--                      &lt;!&ndash;begin::Category title&ndash;&gt;-->
<!--                      <h3 class="fs-5 text-muted m-0 pb-5" data-kt-search-element="category-title">Users</h3>-->
<!--                      &lt;!&ndash;end::Category title&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--                          <img src="assets/media/avatars/300-6.jpg" alt="" />-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Karina Clark</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">Marketing Manager</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--                          <img src="assets/media/avatars/300-2.jpg" alt="" />-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Olivia Bold</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">Software Engineer</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--                          <img src="assets/media/avatars/300-9.jpg" alt="" />-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Ana Clark</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">UI/UX Designer</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--                          <img src="assets/media/avatars/300-14.jpg" alt="" />-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Nick Pitola</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">Art Director</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--                          <img src="assets/media/avatars/300-11.jpg" alt="" />-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Edward Kulnic</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">System Administrator</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Category title&ndash;&gt;-->
<!--                      <h3 class="fs-5 text-muted m-0 pt-5 pb-5" data-kt-search-element="category-title">Customers</h3>-->
<!--                      &lt;!&ndash;end::Category title&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		<img class="w-20px h-20px" src="assets/media/svg/brand-logos/volicity-9.svg" alt="" />-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Company Rbranding</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">UI Design</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		<img class="w-20px h-20px" src="assets/media/svg/brand-logos/tvit.svg" alt="" />-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Company Re-branding</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">Web Development</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		<img class="w-20px h-20px" src="assets/media/svg/misc/infography.svg" alt="" />-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Business Analytics App</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">Administration</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		<img class="w-20px h-20px" src="assets/media/svg/brand-logos/leaf.svg" alt="" />-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">EcoLeaf App Launch</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">Marketing</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		<img class="w-20px h-20px" src="assets/media/svg/brand-logos/tower.svg" alt="" />-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--                          <span class="fs-6 fw-bold">Tower Group Website</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">Google Adwords</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Category title&ndash;&gt;-->
<!--                      <h3 class="fs-5 text-muted m-0 pt-5 pb-5" data-kt-search-element="category-title">Projects</h3>-->
<!--                      &lt;!&ndash;end::Category title&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen005.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z" fill="black" />-->
<!--																				<rect x="7" y="17" width="6" height="2" rx="1" fill="black" />-->
<!--																				<rect x="7" y="12" width="10" height="2" rx="1" fill="black" />-->
<!--																				<rect x="7" y="7" width="6" height="2" rx="1" fill="black" />-->
<!--																				<path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <span class="fs-6 fw-bold">Si-Fi Project by AU Themes</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">#45670</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen032.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<rect x="8" y="9" width="3" height="10" rx="1.5" fill="black" />-->
<!--																				<rect opacity="0.5" x="13" y="5" width="3" height="14" rx="1.5" fill="black" />-->
<!--																				<rect x="18" y="11" width="3" height="8" rx="1.5" fill="black" />-->
<!--																				<rect x="3" y="13" width="3" height="6" rx="1.5" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <span class="fs-6 fw-bold">Shopix Mobile App Planning</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">#45690</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/communication/com012.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z" fill="black" />-->
<!--																				<rect x="6" y="12" width="7" height="2" rx="1" fill="black" />-->
<!--																				<rect x="6" y="7" width="12" height="2" rx="1" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <span class="fs-6 fw-bold">Finance Monitoring SAAS Discussion</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">#21090</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <a href="#" class="d-flex text-dark text-hover-primary align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/communication/com006.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z" fill="black" />-->
<!--																				<path d="M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <span class="fs-6 fw-bold">Dashboard Analitics Launch</span>-->
<!--                          <span class="fs-7 fw-bold text-muted">#34560</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </a>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Items&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Recently viewed&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Recently viewed&ndash;&gt;-->
<!--                  <div class="mb-5" data-kt-search-element="main">-->
<!--                    &lt;!&ndash;begin::Heading&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack fw-bold mb-4">-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="text-muted fs-6 me-2">Recently Searched:</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Heading&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Items&ndash;&gt;-->
<!--                    <div class="scroll-y mh-200px mh-lg-325px">-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/electronics/elc004.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path d="M2 16C2 16.6 2.4 17 3 17H21C21.6 17 22 16.6 22 16V15H2V16Z" fill="black" />-->
<!--																				<path opacity="0.3" d="M21 3H3C2.4 3 2 3.4 2 4V15H22V4C22 3.4 21.6 3 21 3Z" fill="black" />-->
<!--																				<path opacity="0.3" d="M15 17H9V20H15V17Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold">BoomApp by Keenthemes</a>-->
<!--                          <span class="fs-7 text-muted fw-bold">#45789</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/graphs/gra001.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M14 3V21H10V3C10 2.4 10.4 2 11 2H13C13.6 2 14 2.4 14 3ZM7 14H5C4.4 14 4 14.4 4 15V21H8V15C8 14.4 7.6 14 7 14Z" fill="black" />-->
<!--																				<path d="M21 20H20V8C20 7.4 19.6 7 19 7H17C16.4 7 16 7.4 16 8V20H3C2.4 20 2 20.4 2 21C2 21.6 2.4 22 3 22H21C21.6 22 22 21.6 22 21C22 20.4 21.6 20 21 20Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold">"Kept API Project Meeting</a>-->
<!--                          <span class="fs-7 text-muted fw-bold">#84050</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/graphs/gra006.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z" fill="black" />-->
<!--																				<path opacity="0.3" d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold">"KPI Monitoring App Launch</a>-->
<!--                          <span class="fs-7 text-muted fw-bold">#84250</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/graphs/gra002.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M20 8L12.5 5L5 14V19H20V8Z" fill="black" />-->
<!--																				<path d="M21 18H6V3C6 2.4 5.6 2 5 2C4.4 2 4 2.4 4 3V18H3C2.4 18 2 18.4 2 19C2 19.6 2.4 20 3 20H4V21C4 21.6 4.4 22 5 22C5.6 22 6 21.6 6 21V20H21C21.6 20 22 19.6 22 19C22 18.4 21.6 18 21 18Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold">Project Reference FAQ</a>-->
<!--                          <span class="fs-7 text-muted fw-bold">#67945</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/communication/com010.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path d="M6 8.725C6 8.125 6.4 7.725 7 7.725H14L18 11.725V12.925L22 9.725L12.6 2.225C12.2 1.925 11.7 1.925 11.4 2.225L2 9.725L6 12.925V8.725Z" fill="black" />-->
<!--																				<path opacity="0.3" d="M22 9.72498V20.725C22 21.325 21.6 21.725 21 21.725H3C2.4 21.725 2 21.325 2 20.725V9.72498L11.4 17.225C11.8 17.525 12.3 17.525 12.6 17.225L22 9.72498ZM15 11.725H18L14 7.72498V10.725C14 11.325 14.4 11.725 15 11.725Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold">"FitPro App Development</a>-->
<!--                          <span class="fs-7 text-muted fw-bold">#84250</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/finance/fin001.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="black" />-->
<!--																				<path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold">Shopix Mobile App</a>-->
<!--                          <span class="fs-7 text-muted fw-bold">#45690</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center mb-5">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-40px me-4">-->
<!--																	<span class="symbol-label bg-light">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/graphs/gra002.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M20 8L12.5 5L5 14V19H20V8Z" fill="black" />-->
<!--																				<path d="M21 18H6V3C6 2.4 5.6 2 5 2C4.4 2 4 2.4 4 3V18H3C2.4 18 2 18.4 2 19C2 19.6 2.4 20 3 20H4V21C4 21.6 4.4 22 5 22C5.6 22 6 21.6 6 21V20H21C21.6 20 22 19.6 22 19C22 18.4 21.6 18 21 18Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="d-flex flex-column">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold">"Landing UI Design" Launch</a>-->
<!--                          <span class="fs-7 text-muted fw-bold">#24005</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Items&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Recently viewed&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Empty&ndash;&gt;-->
<!--                  <div data-kt-search-element="empty" class="text-center d-none">-->
<!--                    &lt;!&ndash;begin::Icon&ndash;&gt;-->
<!--                    <div class="pt-10 pb-10">-->
<!--                      &lt;!&ndash;begin::Svg Icon | path: icons/duotune/files/fil024.svg&ndash;&gt;-->
<!--                      <span class="svg-icon svg-icon-4x opacity-50">-->
<!--																<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																	<path opacity="0.3" d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" fill="black" />-->
<!--																	<path d="M20 8L14 2V6C14 7.10457 14.8954 8 16 8H20Z" fill="black" />-->
<!--																	<rect x="13.6993" y="13.6656" width="4.42828" height="1.73089" rx="0.865447" transform="rotate(45 13.6993 13.6656)" fill="black" />-->
<!--																	<path d="M15 12C15 14.2 13.2 16 11 16C8.8 16 7 14.2 7 12C7 9.8 8.8 8 11 8C13.2 8 15 9.8 15 12ZM11 9.6C9.68 9.6 8.6 10.68 8.6 12C8.6 13.32 9.68 14.4 11 14.4C12.32 14.4 13.4 13.32 13.4 12C13.4 10.68 12.32 9.6 11 9.6Z" fill="black" />-->
<!--																</svg>-->
<!--															</span>-->
<!--                      &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Icon&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Message&ndash;&gt;-->
<!--                    <div class="pb-15 fw-bold">-->
<!--                      <h3 class="text-gray-600 fs-5 mb-2">No result found</h3>-->
<!--                      <div class="text-muted fs-7">Please try again with a different query</div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Message&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Empty&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;end::Wrapper&ndash;&gt;-->
<!--                &lt;!&ndash;begin::Preferences&ndash;&gt;-->
<!--                <form data-kt-search-element="advanced-options-form" class="pt-1 d-none">-->
<!--                  &lt;!&ndash;begin::Heading&ndash;&gt;-->
<!--                  <h3 class="fw-bold text-dark mb-7">Advanced Search</h3>-->
<!--                  &lt;!&ndash;end::Heading&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="mb-5">-->
<!--                    <input type="text" class="form-control form-control-sm form-control-solid" placeholder="Contains the word" name="query" />-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="mb-5">-->
<!--                    &lt;!&ndash;begin::Radio group&ndash;&gt;-->
<!--                    <div class="nav-group nav-group-fluid">-->
<!--                      &lt;!&ndash;begin::Option&ndash;&gt;-->
<!--                      <label>-->
<!--                        <input type="radio" class="btn-check" name="type" value="has" checked="checked" />-->
<!--                        <span class="btn btn-sm btn-color-muted btn-active btn-active-primary">All</span>-->
<!--                      </label>-->
<!--                      &lt;!&ndash;end::Option&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Option&ndash;&gt;-->
<!--                      <label>-->
<!--                        <input type="radio" class="btn-check" name="type" value="users" />-->
<!--                        <span class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">Users</span>-->
<!--                      </label>-->
<!--                      &lt;!&ndash;end::Option&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Option&ndash;&gt;-->
<!--                      <label>-->
<!--                        <input type="radio" class="btn-check" name="type" value="orders" />-->
<!--                        <span class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">Orders</span>-->
<!--                      </label>-->
<!--                      &lt;!&ndash;end::Option&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Option&ndash;&gt;-->
<!--                      <label>-->
<!--                        <input type="radio" class="btn-check" name="type" value="projects" />-->
<!--                        <span class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">Projects</span>-->
<!--                      </label>-->
<!--                      &lt;!&ndash;end::Option&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Radio group&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="mb-5">-->
<!--                    <input type="text" name="assignedto" class="form-control form-control-sm form-control-solid" placeholder="Assigned to" value="" />-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="mb-5">-->
<!--                    <input type="text" name="collaborators" class="form-control form-control-sm form-control-solid" placeholder="Collaborators" value="" />-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="mb-5">-->
<!--                    &lt;!&ndash;begin::Radio group&ndash;&gt;-->
<!--                    <div class="nav-group nav-group-fluid">-->
<!--                      &lt;!&ndash;begin::Option&ndash;&gt;-->
<!--                      <label>-->
<!--                        <input type="radio" class="btn-check" name="attachment" value="has" checked="checked" />-->
<!--                        <span class="btn btn-sm btn-color-muted btn-active btn-active-primary">Has attachment</span>-->
<!--                      </label>-->
<!--                      &lt;!&ndash;end::Option&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Option&ndash;&gt;-->
<!--                      <label>-->
<!--                        <input type="radio" class="btn-check" name="attachment" value="any" />-->
<!--                        <span class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">Any</span>-->
<!--                      </label>-->
<!--                      &lt;!&ndash;end::Option&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Radio group&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="mb-5">-->
<!--                    <select name="timezone" aria-label="Select a Timezone" data-control="select2" data-placeholder="date_period" class="form-select form-select-sm form-select-solid">-->
<!--                      <option value="next">Within the next</option>-->
<!--                      <option value="last">Within the last</option>-->
<!--                      <option value="between">Between</option>-->
<!--                      <option value="on">On</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="row mb-8">-->
<!--                    &lt;!&ndash;begin::Col&ndash;&gt;-->
<!--                    <div class="col-6">-->
<!--                      <input type="number" name="date_number" class="form-control form-control-sm form-control-solid" placeholder="Lenght" value="" />-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Col&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Col&ndash;&gt;-->
<!--                    <div class="col-6">-->
<!--                      <select name="date_typer" aria-label="Select a Timezone" data-control="select2" data-placeholder="Period" class="form-select form-select-sm form-select-solid">-->
<!--                        <option value="days">Days</option>-->
<!--                        <option value="weeks">Weeks</option>-->
<!--                        <option value="months">Months</option>-->
<!--                        <option value="years">Years</option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Col&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Actions&ndash;&gt;-->
<!--                  <div class="d-flex justify-content-end">-->
<!--                    <button type="reset" class="btn btn-sm btn-light fw-bolder btn-active-light-primary me-2" data-kt-search-element="advanced-options-form-cancel">Cancel</button>-->
<!--                    <a href="../../demo13/dist/pages/search/horizontal.html" class="btn btn-sm fw-bolder btn-primary" data-kt-search-element="advanced-options-form-search">Search</a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Actions&ndash;&gt;-->
<!--                </form>-->
<!--                &lt;!&ndash;end::Preferences&ndash;&gt;-->
<!--                &lt;!&ndash;begin::Preferences&ndash;&gt;-->
<!--                <form data-kt-search-element="preferences" class="pt-1 d-none">-->
<!--                  &lt;!&ndash;begin::Heading&ndash;&gt;-->
<!--                  <h3 class="fw-bold text-dark mb-7">Search Preferences</h3>-->
<!--                  &lt;!&ndash;end::Heading&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="pb-4 border-bottom">-->
<!--                    <label class="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">-->
<!--                      <span class="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">Projects</span>-->
<!--                      <input class="form-check-input" type="checkbox" value="1" checked="checked" />-->
<!--                    </label>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="py-4 border-bottom">-->
<!--                    <label class="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">-->
<!--                      <span class="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">Targets</span>-->
<!--                      <input class="form-check-input" type="checkbox" value="1" checked="checked" />-->
<!--                    </label>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="py-4 border-bottom">-->
<!--                    <label class="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">-->
<!--                      <span class="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">Affiliate Programs</span>-->
<!--                      <input class="form-check-input" type="checkbox" value="1" />-->
<!--                    </label>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="py-4 border-bottom">-->
<!--                    <label class="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">-->
<!--                      <span class="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">Referrals</span>-->
<!--                      <input class="form-check-input" type="checkbox" value="1" checked="checked" />-->
<!--                    </label>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Input group&ndash;&gt;-->
<!--                  <div class="py-4 border-bottom">-->
<!--                    <label class="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">-->
<!--                      <span class="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">Users</span>-->
<!--                      <input class="form-check-input" type="checkbox" value="1" />-->
<!--                    </label>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Actions&ndash;&gt;-->
<!--                  <div class="d-flex justify-content-end pt-7">-->
<!--                    <button type="reset" class="btn btn-sm btn-light fw-bolder btn-active-light-primary me-2" data-kt-search-element="preferences-dismiss">Cancel</button>-->
<!--                    <button type="submit" class="btn btn-sm fw-bolder btn-primary">Save Changes</button>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Actions&ndash;&gt;-->
<!--                </form>-->
<!--                &lt;!&ndash;end::Preferences&ndash;&gt;-->
<!--              </div>-->
<!--              &lt;!&ndash;end::Menu&ndash;&gt;-->
<!--            </div>-->
<!--            &lt;!&ndash;end::Search&ndash;&gt;-->
<!--          </div>-->
          <!--end::Search-->
          <!--begin::Activities-->
<!--          <div class="d-flex align-items-stretch">-->
<!--            &lt;!&ndash;begin::drawer toggle&ndash;&gt;-->
<!--            <div class="topbar-item px-3 px-lg-5" id="kt_activities_toggle">-->
<!--              <i class="bi bi-box-seam fs-3"></i>-->
<!--            </div>-->
<!--            &lt;!&ndash;end::drawer toggle&ndash;&gt;-->
<!--          </div>-->
          <!--end::Activities-->
          <!--begin::Notifications-->
<!--          <div class="d-flex align-items-stretch">-->
<!--            &lt;!&ndash;begin::Menu wrapper&ndash;&gt;-->
<!--            <div class="topbar-item px-3 px-lg-5 position-relative" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" data-kt-menu-flip="bottom">-->
<!--              <i class="bi bi-app-indicator fs-3"></i>-->
<!--            </div>-->
<!--            &lt;!&ndash;begin::Menu&ndash;&gt;-->
<!--            <div class="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px" data-kt-menu="true">-->
<!--              &lt;!&ndash;begin::Heading&ndash;&gt;-->
<!--              <div class="d-flex flex-column bgi-no-repeat rounded-top" style="background-image:url('assets/media/misc/pattern-1.jpg')">-->
<!--                &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                <h3 class="text-white fw-bold px-9 mt-10 mb-6">Notifications-->
<!--                  <span class="fs-8 opacity-75 ps-3">24 reports</span></h3>-->
<!--                &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                &lt;!&ndash;begin::Tabs&ndash;&gt;-->
<!--                <ul class="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9">-->
<!--                  <li class="nav-item">-->
<!--                    <a class="nav-link text-white opacity-75 opacity-state-100 pb-4" data-bs-toggle="tab" href="#kt_topbar_notifications_1">Alerts</a>-->
<!--                  </li>-->
<!--                  <li class="nav-item">-->
<!--                    <a class="nav-link text-white opacity-75 opacity-state-100 pb-4 active" data-bs-toggle="tab" href="#kt_topbar_notifications_2">Updates</a>-->
<!--                  </li>-->
<!--                  <li class="nav-item">-->
<!--                    <a class="nav-link text-white opacity-75 opacity-state-100 pb-4" data-bs-toggle="tab" href="#kt_topbar_notifications_3">Logs</a>-->
<!--                  </li>-->
<!--                </ul>-->
<!--                &lt;!&ndash;end::Tabs&ndash;&gt;-->
<!--              </div>-->
<!--              &lt;!&ndash;end::Heading&ndash;&gt;-->
<!--              &lt;!&ndash;begin::Tab content&ndash;&gt;-->
<!--              <div class="tab-content">-->
<!--                &lt;!&ndash;begin::Tab panel&ndash;&gt;-->
<!--                <div class="tab-pane fade" id="kt_topbar_notifications_1" role="tabpanel">-->
<!--                  &lt;!&ndash;begin::Items&ndash;&gt;-->
<!--                  <div class="scroll-y mh-325px my-5 px-8">-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-35px me-4">-->
<!--																	<span class="symbol-label bg-light-primary">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/technology/teh008.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M11 6.5C11 9 9 11 6.5 11C4 11 2 9 2 6.5C2 4 4 2 6.5 2C9 2 11 4 11 6.5ZM17.5 2C15 2 13 4 13 6.5C13 9 15 11 17.5 11C20 11 22 9 22 6.5C22 4 20 2 17.5 2ZM6.5 13C4 13 2 15 2 17.5C2 20 4 22 6.5 22C9 22 11 20 11 17.5C11 15 9 13 6.5 13ZM17.5 13C15 13 13 15 13 17.5C13 20 15 22 17.5 22C20 22 22 20 22 17.5C22 15 20 13 17.5 13Z" fill="black" />-->
<!--																				<path d="M17.5 16C17.5 16 17.4 16 17.5 16L16.7 15.3C16.1 14.7 15.7 13.9 15.6 13.1C15.5 12.4 15.5 11.6 15.6 10.8C15.7 9.99999 16.1 9.19998 16.7 8.59998L17.4 7.90002H17.5C18.3 7.90002 19 7.20002 19 6.40002C19 5.60002 18.3 4.90002 17.5 4.90002C16.7 4.90002 16 5.60002 16 6.40002V6.5L15.3 7.20001C14.7 7.80001 13.9 8.19999 13.1 8.29999C12.4 8.39999 11.6 8.39999 10.8 8.29999C9.99999 8.19999 9.20001 7.80001 8.60001 7.20001L7.89999 6.5V6.40002C7.89999 5.60002 7.19999 4.90002 6.39999 4.90002C5.59999 4.90002 4.89999 5.60002 4.89999 6.40002C4.89999 7.20002 5.59999 7.90002 6.39999 7.90002H6.5L7.20001 8.59998C7.80001 9.19998 8.19999 9.99999 8.29999 10.8C8.39999 11.5 8.39999 12.3 8.29999 13.1C8.19999 13.9 7.80001 14.7 7.20001 15.3L6.5 16H6.39999C5.59999 16 4.89999 16.7 4.89999 17.5C4.89999 18.3 5.59999 19 6.39999 19C7.19999 19 7.89999 18.3 7.89999 17.5V17.4L8.60001 16.7C9.20001 16.1 9.99999 15.7 10.8 15.6C11.5 15.5 12.3 15.5 13.1 15.6C13.9 15.7 14.7 16.1 15.3 16.7L16 17.4V17.5C16 18.3 16.7 19 17.5 19C18.3 19 19 18.3 19 17.5C19 16.7 18.3 16 17.5 16Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="mb-0 me-2">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Project Alice</a>-->
<!--                          <div class="text-gray-400 fs-7">Phase 1 development</div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">1 hr</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-35px me-4">-->
<!--																	<span class="symbol-label bg-light-danger">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen044.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-danger">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="black" />-->
<!--																				<rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="black" />-->
<!--																				<rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="mb-0 me-2">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">HR Confidential</a>-->
<!--                          <div class="text-gray-400 fs-7">Confidential staff documents</div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">2 hrs</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-35px me-4">-->
<!--																	<span class="symbol-label bg-light-warning">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/finance/fin006.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-warning">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="black" />-->
<!--																				<path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="mb-0 me-2">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Company HR</a>-->
<!--                          <div class="text-gray-400 fs-7">Corporeate staff profiles</div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">5 hrs</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-35px me-4">-->
<!--																	<span class="symbol-label bg-light-success">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/files/fil023.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-success">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M5 15C3.3 15 2 13.7 2 12C2 10.3 3.3 9 5 9H5.10001C5.00001 8.7 5 8.3 5 8C5 5.2 7.2 3 10 3C11.9 3 13.5 4 14.3 5.5C14.8 5.2 15.4 5 16 5C17.7 5 19 6.3 19 8C19 8.4 18.9 8.7 18.8 9C18.9 9 18.9 9 19 9C20.7 9 22 10.3 22 12C22 13.7 20.7 15 19 15H5ZM5 12.6H13L9.7 9.29999C9.3 8.89999 8.7 8.89999 8.3 9.29999L5 12.6Z" fill="black" />-->
<!--																				<path d="M17 17.4V12C17 11.4 16.6 11 16 11C15.4 11 15 11.4 15 12V17.4H17Z" fill="black" />-->
<!--																				<path opacity="0.3" d="M12 17.4H20L16.7 20.7C16.3 21.1 15.7 21.1 15.3 20.7L12 17.4Z" fill="black" />-->
<!--																				<path d="M8 12.6V18C8 18.6 8.4 19 9 19C9.6 19 10 18.6 10 18V12.6H8Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="mb-0 me-2">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Project Redux</a>-->
<!--                          <div class="text-gray-400 fs-7">New frontend admin theme</div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">2 days</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-35px me-4">-->
<!--																	<span class="symbol-label bg-light-primary">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/maps/map001.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-primary">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M6 22H4V3C4 2.4 4.4 2 5 2C5.6 2 6 2.4 6 3V22Z" fill="black" />-->
<!--																				<path d="M18 14H4V4H18C18.8 4 19.2 4.9 18.7 5.5L16 9L18.8 12.5C19.3 13.1 18.8 14 18 14Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="mb-0 me-2">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Project Breafing</a>-->
<!--                          <div class="text-gray-400 fs-7">Product launch status update</div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">21 Jan</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-35px me-4">-->
<!--																	<span class="symbol-label bg-light-info">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen006.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-info">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																				<path opacity="0.3" d="M22 5V19C22 19.6 21.6 20 21 20H19.5L11.9 12.4C11.5 12 10.9 12 10.5 12.4L3 20C2.5 20 2 19.5 2 19V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5ZM7.5 7C6.7 7 6 7.7 6 8.5C6 9.3 6.7 10 7.5 10C8.3 10 9 9.3 9 8.5C9 7.7 8.3 7 7.5 7Z" fill="black" />-->
<!--																				<path d="M19.1 10C18.7 9.60001 18.1 9.60001 17.7 10L10.7 17H2V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V12.9L19.1 10Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="mb-0 me-2">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Banner Assets</a>-->
<!--                          <div class="text-gray-400 fs-7">Collection of banner images</div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">21 Jan</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--                        <div class="symbol symbol-35px me-4">-->
<!--																	<span class="symbol-label bg-light-warning">-->
<!--																		&lt;!&ndash;begin::Svg Icon | path: icons/duotune/art/art002.svg&ndash;&gt;-->
<!--																		<span class="svg-icon svg-icon-2 svg-icon-warning">-->
<!--																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">-->
<!--																				<path opacity="0.3" d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z" fill="black" />-->
<!--																				<path d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z" fill="black" />-->
<!--																			</svg>-->
<!--																		</span>-->
<!--                                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--																	</span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Symbol&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <div class="mb-0 me-2">-->
<!--                          <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Icon Assets</a>-->
<!--                          <div class="text-gray-400 fs-7">Collection of SVG icons</div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">20 March</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Items&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::View more&ndash;&gt;-->
<!--                  <div class="py-3 text-center border-top">-->
<!--                    <a href="../../demo13/dist/pages/user-profile/activity.html" class="btn btn-color-gray-600 btn-active-color-primary">View All-->
<!--                      &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
<!--                      <span class="svg-icon svg-icon-5">-->
<!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
<!--																<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
<!--															</svg>-->
<!--														</span>-->
<!--                      &lt;!&ndash;end::Svg Icon&ndash;&gt;</a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::View more&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;end::Tab panel&ndash;&gt;-->
<!--                &lt;!&ndash;begin::Tab panel&ndash;&gt;-->
<!--                <div class="tab-pane fade show active" id="kt_topbar_notifications_2" role="tabpanel">-->
<!--                  &lt;!&ndash;begin::Wrapper&ndash;&gt;-->
<!--                  <div class="d-flex flex-column px-9">-->
<!--                    &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                    <div class="pt-10 pb-0">-->
<!--                      &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                      <h3 class="text-dark text-center fw-bolder">Get Pro Access</h3>-->
<!--                      &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Text&ndash;&gt;-->
<!--                      <div class="text-center text-gray-600 fw-bold pt-1">Outlines keep you honest. They stoping you from amazing poorly about drive</div>-->
<!--                      &lt;!&ndash;end::Text&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Action&ndash;&gt;-->
<!--                      <div class="text-center mt-5 mb-9">-->
<!--                        <a href="#" class="btn btn-sm btn-primary px-6" data-bs-toggle="modal" data-bs-target="#kt_modal_upgrade_plan">Upgrade</a>-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Action&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Illustration&ndash;&gt;-->
<!--                    <div class="text-center px-4">-->
<!--                      <img class="mw-100 mh-200px" alt="image" src="assets/media/illustrations/unitedpalms-1/1.png" />-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Illustration&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Wrapper&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;end::Tab panel&ndash;&gt;-->
<!--                &lt;!&ndash;begin::Tab panel&ndash;&gt;-->
<!--                <div class="tab-pane fade" id="kt_topbar_notifications_3" role="tabpanel">-->
<!--                  &lt;!&ndash;begin::Items&ndash;&gt;-->
<!--                  <div class="scroll-y mh-325px my-5 px-8">-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-success me-4">200 OK</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">New order</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">Just now</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-danger me-4">500 ERR</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">New customer</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">2 hrs</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-success me-4">200 OK</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">Payment process</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">5 hrs</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-warning me-4">300 WRN</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">Search query</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">2 days</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-success me-4">200 OK</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">API connection</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">1 week</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-success me-4">200 OK</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">Database restore</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">Mar 5</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-warning me-4">300 WRN</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">System update</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">May 15</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-warning me-4">300 WRN</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">Server OS update</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">Apr 3</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-warning me-4">300 WRN</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">API rollback</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">Jun 30</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-danger me-4">500 ERR</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">Refund process</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">Jul 10</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-danger me-4">500 ERR</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">Withdrawal process</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">Sep 10</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                    &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--                    <div class="d-flex flex-stack py-4">-->
<!--                      &lt;!&ndash;begin::Section&ndash;&gt;-->
<!--                      <div class="d-flex align-items-center me-2">-->
<!--                        &lt;!&ndash;begin::Code&ndash;&gt;-->
<!--                        <span class="w-70px badge badge-light-danger me-4">500 ERR</span>-->
<!--                        &lt;!&ndash;end::Code&ndash;&gt;-->
<!--                        &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                        <a href="#" class="text-gray-800 text-hover-primary fw-bold">Mail tasks</a>-->
<!--                        &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash;end::Section&ndash;&gt;-->
<!--                      &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                      <span class="badge badge-light fs-8">Dec 10</span>-->
<!--                      &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash;end::Item&ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Items&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::View more&ndash;&gt;-->
<!--                  <div class="py-3 text-center border-top">-->
<!--                    <a href="../../demo13/dist/pages/user-profile/activity.html" class="btn btn-color-gray-600 btn-active-color-primary">View All-->
<!--                      &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
<!--                      <span class="svg-icon svg-icon-5">-->
<!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
<!--																<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
<!--															</svg>-->
<!--														</span>-->
<!--                      &lt;!&ndash;end::Svg Icon&ndash;&gt;</a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::View more&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;end::Tab panel&ndash;&gt;-->
<!--              </div>-->
<!--              &lt;!&ndash;end::Tab content&ndash;&gt;-->
<!--            </div>-->
<!--            &lt;!&ndash;end::Menu&ndash;&gt;-->
<!--            &lt;!&ndash;end::Menu wrapper&ndash;&gt;-->
<!--          </div>-->
<!--          &lt;!&ndash;end::Notifications&ndash;&gt;-->
<!--          &lt;!&ndash;begin::Chat&ndash;&gt;-->
<!--          <div class="d-flex align-items-stretch">-->
<!--            &lt;!&ndash;begin::Menu wrapper&ndash;&gt;-->
<!--            <div class="topbar-item px-3 px-lg-5 position-relative" id="kt_drawer_chat_toggle">-->
<!--              <i class="bi bi-chat-left-text fs-3"></i>-->
<!--              <span class="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 mt-4 start-50 animation-blink"></span>-->
<!--            </div>-->
<!--            &lt;!&ndash;end::Menu wrapper&ndash;&gt;-->
<!--          </div>-->
<!--          &lt;!&ndash;end::Chat&ndash;&gt;-->
<!--          &lt;!&ndash;begin::Quick links&ndash;&gt;-->
<!--          <div class="d-flex align-items-stretch">-->
<!--            &lt;!&ndash;begin::Menu wrapper&ndash;&gt;-->
<!--            <div class="topbar-item px-3 px-lg-5" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" data-kt-menu-flip="bottom">-->
<!--              <i class="bi bi-bar-chart fs-3"></i>-->
<!--            </div>-->
<!--            &lt;!&ndash;begin::Menu&ndash;&gt;-->
<!--            <div class="menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-325px" data-kt-menu="true">-->
<!--              &lt;!&ndash;begin::Heading&ndash;&gt;-->
<!--              <div class="d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10" style="background-image:url('assets/media/misc/pattern-1.jpg')">-->
<!--                &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--                <h3 class="text-white fw-bold mb-3">Quick Links</h3>-->
<!--                &lt;!&ndash;end::Title&ndash;&gt;-->
<!--                &lt;!&ndash;begin::Status&ndash;&gt;-->
<!--                <span class="badge bg-primary py-2 px-3">25 pending tasks</span>-->
<!--                &lt;!&ndash;end::Status&ndash;&gt;-->
<!--              </div>-->
<!--              &lt;!&ndash;end::Heading&ndash;&gt;-->
<!--              &lt;!&ndash;begin:Nav&ndash;&gt;-->
<!--              <div class="row g-0">-->
<!--                &lt;!&ndash;begin:Item&ndash;&gt;-->
<!--                <div class="col-6">-->
<!--                  <a href="../../demo13/dist/apps/projects/budget.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end border-bottom">-->
<!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/finance/fin009.svg&ndash;&gt;-->
<!--                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">-->
<!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																<path opacity="0.3" d="M15.8 11.4H6C5.4 11.4 5 11 5 10.4C5 9.80002 5.4 9.40002 6 9.40002H15.8C16.4 9.40002 16.8 9.80002 16.8 10.4C16.8 11 16.3 11.4 15.8 11.4ZM15.7 13.7999C15.7 13.1999 15.3 12.7999 14.7 12.7999H6C5.4 12.7999 5 13.1999 5 13.7999C5 14.3999 5.4 14.7999 6 14.7999H14.8C15.3 14.7999 15.7 14.2999 15.7 13.7999Z" fill="black" />-->
<!--																<path d="M18.8 15.5C18.9 15.7 19 15.9 19.1 16.1C19.2 16.7 18.7 17.2 18.4 17.6C17.9 18.1 17.3 18.4999 16.6 18.7999C15.9 19.0999 15 19.2999 14.1 19.2999C13.4 19.2999 12.7 19.2 12.1 19.1C11.5 19 11 18.7 10.5 18.5C10 18.2 9.60001 17.7999 9.20001 17.2999C8.80001 16.8999 8.49999 16.3999 8.29999 15.7999C8.09999 15.1999 7.80001 14.7 7.70001 14.1C7.60001 13.5 7.5 12.8 7.5 12.2C7.5 11.1 7.7 10.1 8 9.19995C8.3 8.29995 8.79999 7.60002 9.39999 6.90002C9.99999 6.30002 10.7 5.8 11.5 5.5C12.3 5.2 13.2 5 14.1 5C15.2 5 16.2 5.19995 17.1 5.69995C17.8 6.09995 18.7 6.6 18.8 7.5C18.8 7.9 18.6 8.29998 18.3 8.59998C18.2 8.69998 18.1 8.69993 18 8.79993C17.7 8.89993 17.4 8.79995 17.2 8.69995C16.7 8.49995 16.5 7.99995 16 7.69995C15.5 7.39995 14.9 7.19995 14.2 7.19995C13.1 7.19995 12.1 7.6 11.5 8.5C10.9 9.4 10.5 10.6 10.5 12.2C10.5 13.3 10.7 14.2 11 14.9C11.3 15.6 11.7 16.1 12.3 16.5C12.9 16.9 13.5 17 14.2 17C15 17 15.7 16.8 16.2 16.4C16.8 16 17.2 15.2 17.9 15.1C18 15 18.5 15.2 18.8 15.5Z" fill="black" />-->
<!--															</svg>-->
<!--														</span>-->
<!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                    <span class="fs-5 fw-bold text-gray-800 mb-0">Accounting</span>-->
<!--                    <span class="fs-7 text-gray-400">eCommerce</span>-->
<!--                  </a>-->
<!--                </div>-->
<!--                &lt;!&ndash;end:Item&ndash;&gt;-->
<!--                &lt;!&ndash;begin:Item&ndash;&gt;-->
<!--                <div class="col-6">-->
<!--                  <a href="../../demo13/dist/apps/projects/settings.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-bottom">-->
<!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/communication/com010.svg&ndash;&gt;-->
<!--                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">-->
<!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																<path d="M6 8.725C6 8.125 6.4 7.725 7 7.725H14L18 11.725V12.925L22 9.725L12.6 2.225C12.2 1.925 11.7 1.925 11.4 2.225L2 9.725L6 12.925V8.725Z" fill="black" />-->
<!--																<path opacity="0.3" d="M22 9.72498V20.725C22 21.325 21.6 21.725 21 21.725H3C2.4 21.725 2 21.325 2 20.725V9.72498L11.4 17.225C11.8 17.525 12.3 17.525 12.6 17.225L22 9.72498ZM15 11.725H18L14 7.72498V10.725C14 11.325 14.4 11.725 15 11.725Z" fill="black" />-->
<!--															</svg>-->
<!--														</span>-->
<!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                    <span class="fs-5 fw-bold text-gray-800 mb-0">Administration</span>-->
<!--                    <span class="fs-7 text-gray-400">Console</span>-->
<!--                  </a>-->
<!--                </div>-->
<!--                &lt;!&ndash;end:Item&ndash;&gt;-->
<!--                &lt;!&ndash;begin:Item&ndash;&gt;-->
<!--                <div class="col-6">-->
<!--                  <a href="../../demo13/dist/apps/projects/list.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end">-->
<!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/abstract/abs042.svg&ndash;&gt;-->
<!--                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">-->
<!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																<path d="M18 21.6C16.6 20.4 9.1 20.3 6.3 21.2C5.7 21.4 5.1 21.2 4.7 20.8L2 18C4.2 15.8 10.8 15.1 15.8 15.8C16.2 18.3 17 20.5 18 21.6ZM18.8 2.8C18.4 2.4 17.8 2.20001 17.2 2.40001C14.4 3.30001 6.9 3.2 5.5 2C6.8 3.3 7.4 5.5 7.7 7.7C9 7.9 10.3 8 11.7 8C15.8 8 19.8 7.2 21.5 5.5L18.8 2.8Z" fill="black" />-->
<!--																<path opacity="0.3" d="M21.2 17.3C21.4 17.9 21.2 18.5 20.8 18.9L18 21.6C15.8 19.4 15.1 12.8 15.8 7.8C18.3 7.4 20.4 6.70001 21.5 5.60001C20.4 7.00001 20.2 14.5 21.2 17.3ZM8 11.7C8 9 7.7 4.2 5.5 2L2.8 4.8C2.4 5.2 2.2 5.80001 2.4 6.40001C2.7 7.40001 3.00001 9.2 3.10001 11.7C3.10001 15.5 2.40001 17.6 2.10001 18C3.20001 16.9 5.3 16.2 7.8 15.8C8 14.2 8 12.7 8 11.7Z" fill="black" />-->
<!--															</svg>-->
<!--														</span>-->
<!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                    <span class="fs-5 fw-bold text-gray-800 mb-0">Projects</span>-->
<!--                    <span class="fs-7 text-gray-400">Pending Tasks</span>-->
<!--                  </a>-->
<!--                </div>-->
<!--                &lt;!&ndash;end:Item&ndash;&gt;-->
<!--                &lt;!&ndash;begin:Item&ndash;&gt;-->
<!--                <div class="col-6">-->
<!--                  <a href="../../demo13/dist/apps/projects/users.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light">-->
<!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/finance/fin006.svg&ndash;&gt;-->
<!--                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">-->
<!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--																<path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="black" />-->
<!--																<path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="black" />-->
<!--															</svg>-->
<!--														</span>-->
<!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
<!--                    <span class="fs-5 fw-bold text-gray-800 mb-0">Customers</span>-->
<!--                    <span class="fs-7 text-gray-400">Latest cases</span>-->
<!--                  </a>-->
<!--                </div>-->
<!--                &lt;!&ndash;end:Item&ndash;&gt;-->
<!--              </div>-->
<!--              &lt;!&ndash;end:Nav&ndash;&gt;-->
<!--              &lt;!&ndash;begin::View more&ndash;&gt;-->
<!--              <div class="py-2 text-center border-top">-->
<!--                <a href="../../demo13/dist/pages/user-profile/activity.html" class="btn btn-color-gray-600 btn-active-color-primary">View All-->
<!--                  &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
<!--                  <span class="svg-icon svg-icon-5">-->
<!--													<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--														<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
<!--														<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
<!--													</svg>-->
<!--												</span>-->
<!--                  &lt;!&ndash;end::Svg Icon&ndash;&gt;</a>-->
<!--              </div>-->
<!--              &lt;!&ndash;end::View more&ndash;&gt;-->
<!--            </div>-->
<!--            &lt;!&ndash;end::Menu&ndash;&gt;-->
<!--            &lt;!&ndash;end::Menu wrapper&ndash;&gt;-->
<!--          </div>-->
<!--          &lt;!&ndash;end::Quick links&ndash;&gt;-->
<!--          &lt;!&ndash;begin::Theme mode&ndash;&gt;-->
<!--          <div class="d-flex align-items-center">-->
<!--            &lt;!&ndash;begin::Theme mode docs&ndash;&gt;-->
<!--            <a class="topbar-item px-3 px-lg-5" href="../../demo13/dist/documentation/getting-started/dark-mode.html">-->
<!--              <i class="fonticon-sun fs-2"></i>-->
<!--            </a>-->
<!--            &lt;!&ndash;end::Theme mode docs&ndash;&gt;-->
<!--          </div>-->
          <!--end::Theme mode-->
          <!--begin::User-->
          <div class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle">
            <!--begin::Menu wrapper-->
            <div class="cursor-pointer symbol symbol-30px symbol-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <img :src="`${publicPath}logo.png`"  alt="user" />
            </div>
            <!--begin::User account menu-->
            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px" data-kt-menu="true">
              <!--begin::Menu item-->
              <div class="menu-item px-3">
                <div class="menu-content d-flex align-items-center px-3">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-50px me-5">
                    <img alt="Logo" :src="`${publicPath}logo.png`" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Username-->
                  <div class="d-flex flex-column">
                    <div class="fw-bolder d-flex align-items-center fs-5">{{$fullName}}
                      <span class="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">{{$role}}</span></div>
                    <a href="#" class="fw-bold text-muted text-hover-primary fs-7">{{$email}}</a>
                  </div>
                  <!--end::Username-->
                </div>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu separator-->
              <div class="separator my-2"></div>
              <!--end::Menu separator-->
              <!--begin::Menu item-->
              <div class="menu-item px-5">
                <router-link :to="{name: 'UserProfile'}" class="menu-link px-5">
                  {{$t('profile')}}
                </router-link>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <!--                <div class="menu-item px-5">-->
              <!--                  <a href="../../demo1/dist/apps/projects/list.html" class="menu-link px-5">-->
              <!--&lt;!&ndash;                    <span class="menu-text">My Projects</span>&ndash;&gt;-->
              <!--&lt;!&ndash;                    <span class="menu-badge">&ndash;&gt;-->
              <!--&lt;!&ndash;														<span class="badge badge-light-danger badge-circle fw-bolder fs-7">3</span>&ndash;&gt;-->
              <!--&lt;!&ndash;													</span>&ndash;&gt;-->
              <!--                  </a>-->
              <!--                </div>-->
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start">
                <!--                  <a href="#" class="menu-link px-5">-->
                <!--                    <span class="menu-title">My Subscription</span>-->
                <!--                    <span class="menu-arrow"></span>-->
                <!--                  </a>-->
                <!--begin::Menu sub-->
                <!--                  <div class="menu-sub menu-sub-dropdown w-175px py-4">-->
                <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
                <!--                    <div class="menu-item px-3">-->
                <!--                      <a href="../../demo1/dist/account/referrals.html" class="menu-link px-5">Referrals</a>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
                <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
                <!--                    <div class="menu-item px-3">-->
                <!--                      <a href="../../demo1/dist/account/billing.html" class="menu-link px-5">Billing</a>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
                <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
                <!--                    <div class="menu-item px-3">-->
                <!--                      <a href="../../demo1/dist/account/statements.html" class="menu-link px-5">Payments</a>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
                <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
                <!--                    <div class="menu-item px-3">-->
                <!--                      <a href="../../demo1/dist/account/statements.html" class="menu-link d-flex flex-stack px-5">Statements-->
                <!--                        <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="View your statements"></i></a>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
                <!--                    &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
                <!--                    <div class="separator my-2"></div>-->
                <!--                    &lt;!&ndash;end::Menu separator&ndash;&gt;-->
                <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
                <!--                    <div class="menu-item px-3">-->
                <!--                      <div class="menu-content px-3">-->
                <!--                        <label class="form-check form-switch form-check-custom form-check-solid">-->
                <!--                          <input class="form-check-input w-30px h-20px" type="checkbox" value="1" checked="checked" name="notifications" />-->
                <!--                          <span class="form-check-label text-muted fs-7">Notifications</span>-->
                <!--                        </label>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
                <!--                  </div>-->
                <!--end::Menu sub-->
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5">
                <!--                  <a href="../../demo1/dist/account/statements.html" class="menu-link px-5">My Statements</a>-->
              </div>
              <!--end::Menu item-->
              <!--begin::Menu separator-->
              <div class="separator my-2"></div>
              <!--end::Menu separator-->
              <!--begin::Menu item-->
<!--              <div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start">-->
<!--                <a href="#" class="menu-link px-5">-->
<!--													<span class="menu-title position-relative">{{$t('languages')}}-->
<!--                            &lt;!&ndash;													<span class="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0">English&ndash;&gt;-->
<!--                            &lt;!&ndash;													<img class="w-15px h-15px rounded-1 ms-2" src="assets/media/flags/united-states.svg" alt="" /></span>&ndash;&gt;-->
<!--                          </span>-->
<!--                </a>-->
<!--                &lt;!&ndash;begin::Menu sub&ndash;&gt;-->
<!--                <div v-if="$dashboardData" class="menu-sub menu-sub-dropdown w-175px py-4">-->
<!--                  &lt;!&ndash;begin::Menu item&ndash;&gt;-->
<!--                  <div v-for="language in $dashboardData.allLanguages" :key="language" class="menu-item px-3">-->
<!--                    <a @click.prevent="switchLocale(language)" class="menu-link d-flex px-5 active">-->
<!--														<span class="symbol symbol-20px me-4">-->
<!--&lt;!&ndash;															<img class="rounded-1" src="assets/media/flags/united-states.svg" alt="" />&ndash;&gt;-->
<!--														</span>{{$t(language.language_universal)}}</a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end::Menu item&ndash;&gt;-->
<!--                  &lt;!&ndash;begin::Menu item&ndash;&gt;-->
<!--                  &lt;!&ndash;                    <div class="menu-item px-3">&ndash;&gt;-->
<!--                  &lt;!&ndash;                      <a href="../../demo1/dist/account/settings.html" class="menu-link d-flex px-5">&ndash;&gt;-->
<!--                  &lt;!&ndash;														<span class="symbol symbol-20px me-4">&ndash;&gt;-->
<!--                  &lt;!&ndash;															<img class="rounded-1" src="assets/media/flags/spain.svg" alt="" />&ndash;&gt;-->
<!--                  &lt;!&ndash;														</span>Spanish</a>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    &lt;!&ndash;end::Menu item&ndash;&gt;&ndash;&gt;-->
<!--                  &lt;!&ndash;                    &lt;!&ndash;begin::Menu item&ndash;&gt;&ndash;&gt;-->
<!--                  &lt;!&ndash;                    <div class="menu-item px-3">&ndash;&gt;-->
<!--                  &lt;!&ndash;                      <a href="../../demo1/dist/account/settings.html" class="menu-link d-flex px-5">&ndash;&gt;-->
<!--                  &lt;!&ndash;														<span class="symbol symbol-20px me-4">&ndash;&gt;-->
<!--                  &lt;!&ndash;															<img class="rounded-1" src="assets/media/flags/germany.svg" alt="" />&ndash;&gt;-->
<!--                  &lt;!&ndash;														</span>German</a>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    &lt;!&ndash;end::Menu item&ndash;&gt;&ndash;&gt;-->
<!--                  &lt;!&ndash;                    &lt;!&ndash;begin::Menu item&ndash;&gt;&ndash;&gt;-->
<!--                  &lt;!&ndash;                    <div class="menu-item px-3">&ndash;&gt;-->
<!--                  &lt;!&ndash;                      <a href="../../demo1/dist/account/settings.html" class="menu-link d-flex px-5">&ndash;&gt;-->
<!--                  &lt;!&ndash;														<span class="symbol symbol-20px me-4">&ndash;&gt;-->
<!--                  &lt;!&ndash;															<img class="rounded-1" src="assets/media/flags/japan.svg" alt="" />&ndash;&gt;-->
<!--                  &lt;!&ndash;														</span>Japanese</a>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    &lt;!&ndash;end::Menu item&ndash;&gt;&ndash;&gt;-->
<!--                  &lt;!&ndash;                    &lt;!&ndash;begin::Menu item&ndash;&gt;&ndash;&gt;-->
<!--                  &lt;!&ndash;                    <div class="menu-item px-3">&ndash;&gt;-->
<!--                  &lt;!&ndash;                      <a href="../../demo1/dist/account/settings.html" class="menu-link d-flex px-5">&ndash;&gt;-->
<!--                  &lt;!&ndash;														<span class="symbol symbol-20px me-4">&ndash;&gt;-->
<!--                  &lt;!&ndash;															<img class="rounded-1" src="assets/media/flags/france.svg" alt="" />&ndash;&gt;-->
<!--                  &lt;!&ndash;														</span>French</a>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  &lt;!&ndash;end::Menu item&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;end::Menu sub&ndash;&gt;-->
<!--              </div>-->
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <!--                <div class="menu-item px-5 my-1">-->
              <!--                  <a href="../../demo1/dist/account/settings.html" class="menu-link px-5">Account Settings</a>-->
              <!--                </div>-->
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5">
                <a @click.prevent="signOut"  class="menu-link px-5">{{$t('signOut')}} </a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu separator-->
<!--              <div class="separator my-2"></div>-->
              <!--end::Menu separator-->
              <!--begin::Menu item-->
              <!--                <div class="menu-item px-5">-->
              <!--                  <div class="menu-content px-5">-->
              <!--                    <label class="form-check form-switch form-check-custom form-check-solid pulse pulse-success" for="kt_user_menu_dark_mode_toggle">-->
              <!--                      <input class="form-check-input w-30px h-20px" type="checkbox" value="1" name="mode" id="kt_user_menu_dark_mode_toggle" data-kt-url="../../demo1/dist/index.html" />-->
              <!--                      <span class="pulse-ring ms-n1"></span>-->
              <!--                      <span class="form-check-label text-gray-600 fs-7">Dark Mode</span>-->
              <!--                    </label>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--end::Menu item-->
            </div>
            <!--end::User account menu-->
            <!--end::Menu wrapper-->
          </div>
          <!--end::User -->
          <!--begin::Heaeder menu toggle-->
          <div class="d-flex align-items-stretch d-lg-none px-3 me-n3" title="Show header menu">
            <div class="topbar-item" id="kt_header_menu_mobile_toggle">
              <i class="bi bi-text-left fs-1"></i>
            </div>
          </div>
          <!--end::Heaeder menu toggle-->
        </div>
        <!--end::Toolbar wrapper-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Container-->
  </div>
  <!--end::Header-->
</template>

<script>
import axios from "/src/plugins/axios";

export default {
  name: "Header",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      form:{}
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch('logout');
    },
    switchLocale(language) {
      // this.$axios.post('accountSettings/profile', {'spec': 'defLang', 'value': language.id}).then(response => {
      //   if (response.data.status === "success") {
      //     this.$store.dispatch('dashboard');
          this.$i18n.locale = language.language_universal;
          let htmlEl = document.querySelector("html");
          let dir = '';
          if (language.rtl == 'active') {
            dir = 'rtl';
          } else {
            dir = 'ltr';
          }
      localStorage.setItem('languageUniversal',language.language_universal);
      axios.defaults.headers.common["lang"] = language.language_universal;
      htmlEl.setAttribute('dir', dir);
          htmlEl.setAttribute('lang', language.language_universal);
      this.$router.go()	// Refreshes page
          // this.$toast.success(response.data.message);
        // } else {
        //   this.$toast.error(response.data.message);
        // }
    //   });
    // }

  },
  },

}
</script>



<style scoped>

</style>